'use client';

import React from 'react';
import { User, Phone, Mail } from 'lucide-react';
import { useHydrationSafe } from '@/hooks/useHydrationSafe';

interface NamePhoneFieldsProps {
  name: string;
  phone: string;
  email: string;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

const NamePhoneFields: React.FC<NamePhoneFieldsProps> = ({
  name,
  phone,
  email,
  handleInputChange
}) => {
  const { getInputProps } = useHydrationSafe();

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
        <div className="relative">
          <User className="absolute left-4 top-4 w-5 h-5 text-gray-400" />
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={name}
            onChange={handleInputChange}
            className="w-full pl-12 pr-4 py-4 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-green-500/20 focus:border-green-500 text-gray-900 placeholder-gray-400 text-base font-medium transition-all duration-300 bg-white"
            required
            {...getInputProps('text')}
          />
        </div>
        
        <div className="relative">
          <Phone className="absolute left-4 top-4 w-5 h-5 text-gray-400" />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={phone}
            onChange={handleInputChange}
            className="w-full pl-12 pr-4 py-4 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-green-500/20 focus:border-green-500 text-gray-900 placeholder-gray-400 text-base font-medium transition-all duration-300 bg-white"
            required
            {...getInputProps('tel')}
          />
        </div>
      </div>
      
      <div className="relative">
        <Mail className="absolute left-4 top-4 w-5 h-5 text-gray-400" />
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={email}
          onChange={handleInputChange}
          className="w-full pl-12 pr-4 py-4 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-green-500/20 focus:border-green-500 text-gray-900 placeholder-gray-400 text-base font-medium transition-all duration-300 bg-white"
          required
          {...getInputProps('email')}
        />
      </div>
    </div>
  );
};

export default NamePhoneFields;